import { SelectionCard } from 'components/Profile';
import { choiceBtnSelected, choiceBtnUnselected } from 'components/Profile/helper';
import { OWN_PLAN, PLAN_OWNERSHIP, otherPolicyHolders } from '../helper';
import Heading from './Heading';
import PolicyHolderSsn from './PolicyHolderSsn';

const optionCard = (selected: boolean) =>
  `flex cursor-pointer items-center gap-3 rounded-xl border p-4 transition-colors ${selected ? 'border-teamcare-blue bg-blue-50/50' : 'border-gray-200 bg-white hover:border-gray-300'}`;

const PolicyHolder = ({ policyHolder, onChange }) => {
  const isOwnPlan = policyHolder === OWN_PLAN;

  const setOwnPlan = (own: boolean) => onChange(own ? OWN_PLAN : otherPolicyHolders[0].title);

  return (
    <>
      <Heading
        title="Is this plan in your name?"
        description="We ask because claims go under the policy holder's name."
      />

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {PLAN_OWNERSHIP.map(({ own, label }) => {
          const selected = own === isOwnPlan;

          return (
            <label key={label} className={optionCard(selected)}>
              <input
                type="radio"
                name="own_plan"
                checked={selected}
                onChange={() => setOwnPlan(own)}
                className="radio radio-sm radio-primary"
              />
              <span className="text-sm font-bold text-secondary-900">{label}</span>
            </label>
          );
        })}
      </div>

      {!isOwnPlan && (
        <div className="mt-5 border-t border-gray-100 pt-5">
          <p className="mb-3 text-sm font-medium text-secondary-900">Whose plan is it?</p>

          <SelectionCard
            options={otherPolicyHolders}
            selectedOption={policyHolder}
            onPress={onChange}
            btnStyle="btn w-full sm:w-[32%] mb-2 rounded-xl"
            selectedStyle={choiceBtnSelected}
            unselectedStyle={choiceBtnUnselected}
          />
        </div>
      )}

      <div className="mt-5 border-t border-gray-100 pt-5">
        <PolicyHolderSsn />
      </div>
    </>
  );
};

export default PolicyHolder;
